import {Component, OnInit} from '@angular/core';
import {CorePage} from "../../../core/page/core-page/core.page";
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FieldAccess, FormRegistrationFieldsDto, RegistrationRequestOtpDto} from "../../types/registration.types";
import {SignUpService} from "../../service/sign-up.service";
import {CoreApiService} from "../../../core/service/core-api.service";
import {RegistrationApiService} from "../../api/registration-api.service";



@Component({
  selector: 'registration-page',
  templateUrl: './registration.page.html',
  styleUrls: ['registration.page.scss']
})
export class RegistrationPage extends CorePage implements OnInit {

  override defaultLabel: string = "Registration";

  steps: MenuItem[] | undefined;
  activeStep: number = 3;
  formGroup: FormGroup | undefined;
  extraFields: string[] = ["password", "confirmPassword", "deviceInfo", "profileImage"];

  constructor(
    protected override route: ActivatedRoute,
    protected router: Router,
    protected signUpService: SignUpService,
    protected formBuilder: FormBuilder,
    protected registrationService: RegistrationApiService,
    protected coreApiService: CoreApiService,
  ) {
    super(route);
  }

  override ngOnInit() {
    super.ngOnInit();

    this.route.params.subscribe(params => {

      let routeStep = +params['step'];

      if (routeStep > 1 && (!this.signUpService.registrationGuid || !this.signUpService.phoneNumber)) {
        this.router.navigate(['/registration', 1]);
      } else {
        this.activeStep = routeStep;
      }

    });

    this.initializeSteps();
    this.initComponent();
  }

  refreshComponent() {
    this.initialized = true;
  }

  createFormGroup() {
    const formFields = this.signUpService.registrationForm.formFields;
    this.formGroup = this.buildUiForm(formFields);

    const dto: RegistrationRequestOtpDto = {
      phoneNumber: this.signUpService.phoneNumber as string,
      registrationGuid: this.signUpService.registrationGuid as string,
      deviceInfo: this.coreApiService.getDeviceInfo()
    }
    this.formGroup.patchValue(dto);

  }

  buildUiForm(formFields: FormRegistrationFieldsDto): FormGroup {
    const group: any = {};
      for (let formFieldsKey in formFields) {
        const field = formFields[formFieldsKey]
        let validators = [];

        if (field.access == 'update' as any) {
          // if (field.access == FieldAccess.UPDATE) {

          if (field.id == 'email') {
            validators.push(Validators.email)
          }

          if (field.id == 'addressCasually') {
            field.value = true;
          }

          if (field.id == 'maritalStatus' || field.id == 'childrenCount' || field.id == 'addressLine2') {
            //optional values, do nothing
          } else {
            validators.push(Validators.required)
          }

          group[field.id] = [field.value, validators];
        }
      }

      for (let item of this.extraFields) {
        let validators = [Validators.required];
        group[item] = ['', validators];
      }

    return this.formBuilder.group(group);
  }

  initializeSteps() {
    this.steps = [
      {id: '1', label: 'Über dich'}, // Personal Info
      {id: '2', label: 'Deine Anschrift'}, // Address
      {id: '3', label: 'Kontaktaufnahme'}, //Notifications
      {id: '4', label: 'Bestätigungen'}, //Affirmations
      {id: '5', label: 'Account einrichten '}, // Account Setup
    ]
  }

  initComponent() {
    this.createFormGroup();
    this.refreshComponent();
  }

  handleStepChange(nextStep: number) {
    this.router.navigate(['/registration', nextStep]);
  }

  navigatePreviousStep() {
    this.activeStep--;
  }

  navigateNextStep() {
    this.activeStep++;
  }

}
